export default {
  props: {
    variant: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: ""
    }
  },
  computed: {
    buttonClass() {
      return "btn-" + this.variant;
    }
  }
};
